// extracted by mini-css-extract-plugin
export default {"single_btn":"ButtonGroupContainer_single_btn__vQIPK","white_border":"ButtonGroupContainer_white_border__7bZU1"};